import { Box } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { Permitted } from 'components'

import { SSOCorporateGroupTableRow } from './components'

import constants from 'constants/index'

const SSOCorporateGroupTable = ({ ssoCorporateGroups, refresh }) => {
  const { CREATE, SHOW, EDIT } = constants.permissions.SSO_CORPORATE_GROUP

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhum Grupo Empresarial com SSO-SAML configurado encontrado"
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell align="left">Nome</TableCell>
              <TableCell align="left">Domínio</TableCell>
              <TableCell align="left">Plataforma</TableCell>
              <TableCell align="left">SCIM</TableCell>
              <TableCell align="left">Provedor de Identidade</TableCell>
              <Permitted someTags={[CREATE, EDIT, SHOW]}>
                <TableCell align="left">Ações</TableCell>
              </Permitted>
            </TableRow>
          </TableHead>
          <TableBody>
            {ssoCorporateGroups?.map((ssoCorporateGroup) => (
              <SSOCorporateGroupTableRow
                refresh={refresh}
                ssoCorporateGroup={ssoCorporateGroup}
                key={ssoCorporateGroup.id}
              />
            ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

export default SSOCorporateGroupTable
